import React from "react";
import Modal from "react-bootstrap/Modal";

const tabDeleteModal = (props) => {
  return (
    <Modal
      className="template-modal"
      size="sm"
      centered
      show={props.showTabDeleteModal}
      onHide={props.tabDeleteCloseHandler}
    >
      <div role="document" className="modal-sm">
        <div className="modal-header  border-0 is-size-h4 bold">Delete Tab</div>
        <div className="modal-body">
          <div className="is-size-body-1 d-flex">
            Are you sure you want to delete
            {props.tabName && (
              <p className="restricted-title px-1">
                <strong> {props.tabName} </strong>
              </p>
            )}{" "}
            tab?
          </div>
        </div>
        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn-secondary"
            onClick={props.tabDeleteYesHandler}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={props.tabDeleteCloseHandler}
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default tabDeleteModal;
